export enum BatchCode {
    onboarding = "onboarding",
    onboardingattachment = "onboardingattachment",
    breakTheIce = "breakTheIce",
    introductionDeclined = "introductionDeclined",
    onFirstEnter = "onFirstEnter",
    itsQuietHere = "itsQuietHere",
    askUnmatch = "askUnmatch",
    otherQuestions = "otherQuestions"
}
export enum BatchType {
    OnBoarding = 1,
    Questionnaire = 2,
    BreakTheIce = 3,
    LoraChat = 4,
    LoraChatCollapsable = 5
}

export enum BatchTriggerType {
    UserTriggered = 0,
    OnSignup
}

export class Batch {
    id: number

    brandId: number

    name: string
    displayName: string

    description: string

    created: Date

    
    createdBy: number


    updated: Date


    updatedBy: number


    derivedFrom: number


    version: string


    batchType: BatchType


    comment: string


    workflowStatusId: number


    workflowSourceBatchId: number

    
}